import script from "./TvmAnnuity.vue?vue&type=script&setup=true&lang=js"
export * from "./TvmAnnuity.vue?vue&type=script&setup=true&lang=js"

import "./TvmAnnuity.vue?vue&type=style&index=0&id=56f851e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f851e9"]])

export default __exports__